/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HomeHealthCertificationCriteriaF2f } from './HomeHealthCertificationCriteriaF2f';
import {
    HomeHealthCertificationCriteriaF2fFromJSON,
    HomeHealthCertificationCriteriaF2fFromJSONTyped,
    HomeHealthCertificationCriteriaF2fToJSON,
    HomeHealthCertificationCriteriaF2fToJSONTyped,
} from './HomeHealthCertificationCriteriaF2f';
import type { HomeHealthCertificationCriteriaUnderPractitionerCare } from './HomeHealthCertificationCriteriaUnderPractitionerCare';
import {
    HomeHealthCertificationCriteriaUnderPractitionerCareFromJSON,
    HomeHealthCertificationCriteriaUnderPractitionerCareFromJSONTyped,
    HomeHealthCertificationCriteriaUnderPractitionerCareToJSON,
    HomeHealthCertificationCriteriaUnderPractitionerCareToJSONTyped,
} from './HomeHealthCertificationCriteriaUnderPractitionerCare';
import type { HomeHealthCertificationCriteriaHomebound } from './HomeHealthCertificationCriteriaHomebound';
import {
    HomeHealthCertificationCriteriaHomeboundFromJSON,
    HomeHealthCertificationCriteriaHomeboundFromJSONTyped,
    HomeHealthCertificationCriteriaHomeboundToJSON,
    HomeHealthCertificationCriteriaHomeboundToJSONTyped,
} from './HomeHealthCertificationCriteriaHomebound';

/**
 * 
 * @export
 * @interface HomeHealthCertificationCriteria
 */
export interface HomeHealthCertificationCriteria {
    /**
     * 
     * @type {HomeHealthCertificationCriteriaF2f}
     * @memberof HomeHealthCertificationCriteria
     */
    f2f: HomeHealthCertificationCriteriaF2f;
    /**
     * 
     * @type {HomeHealthCertificationCriteriaHomebound}
     * @memberof HomeHealthCertificationCriteria
     */
    homebound: HomeHealthCertificationCriteriaHomebound;
    /**
     * 
     * @type {HomeHealthCertificationCriteriaHomebound}
     * @memberof HomeHealthCertificationCriteria
     */
    skilled_need: HomeHealthCertificationCriteriaHomebound;
    /**
     * 
     * @type {HomeHealthCertificationCriteriaUnderPractitionerCare}
     * @memberof HomeHealthCertificationCriteria
     */
    under_practitioner_care: HomeHealthCertificationCriteriaUnderPractitionerCare;
}

/**
 * Check if a given object implements the HomeHealthCertificationCriteria interface.
 */
export function instanceOfHomeHealthCertificationCriteria(value: object): value is HomeHealthCertificationCriteria {
    if (!('f2f' in value) || value['f2f'] === undefined) return false;
    if (!('homebound' in value) || value['homebound'] === undefined) return false;
    if (!('skilled_need' in value) || value['skilled_need'] === undefined) return false;
    if (!('under_practitioner_care' in value) || value['under_practitioner_care'] === undefined) return false;
    return true;
}

export function HomeHealthCertificationCriteriaFromJSON(json: any): HomeHealthCertificationCriteria {
    return HomeHealthCertificationCriteriaFromJSONTyped(json, false);
}

export function HomeHealthCertificationCriteriaFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeHealthCertificationCriteria {
    if (json == null) {
        return json;
    }
    return {
        
        'f2f': HomeHealthCertificationCriteriaF2fFromJSON(json['f2f']),
        'homebound': HomeHealthCertificationCriteriaHomeboundFromJSON(json['homebound']),
        'skilled_need': HomeHealthCertificationCriteriaHomeboundFromJSON(json['skilled_need']),
        'under_practitioner_care': HomeHealthCertificationCriteriaUnderPractitionerCareFromJSON(json['under_practitioner_care']),
    };
}

export function HomeHealthCertificationCriteriaToJSON(json: any): HomeHealthCertificationCriteria {
    return HomeHealthCertificationCriteriaToJSONTyped(json, false);
}

export function HomeHealthCertificationCriteriaToJSONTyped(value?: HomeHealthCertificationCriteria | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'f2f': HomeHealthCertificationCriteriaF2fToJSON(value['f2f']),
        'homebound': HomeHealthCertificationCriteriaHomeboundToJSON(value['homebound']),
        'skilled_need': HomeHealthCertificationCriteriaHomeboundToJSON(value['skilled_need']),
        'under_practitioner_care': HomeHealthCertificationCriteriaUnderPractitionerCareToJSON(value['under_practitioner_care']),
    };
}

